export default __webpack_public_path__ + "static/media/IMG_4558-min.f18d1c53.JPG";